import React, { useState } from 'react';

const POSEmployeeManagement = ({ employees, onAddEmployee, onUpdateEmployee, onDeleteEmployee }) => {
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [pin, setPin] = useState('');   // 🔥 NUEVO

  const handleEdit = (employee) => {
    setEditingEmployee(employee);
    setName(employee.name);
    setRole(employee.role);
    setPin(''); // no mostrar PIN guardado por seguridad
  };

  const handleCancelEdit = () => {
    setEditingEmployee(null);
    setName('');
    setRole('');
    setPin('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !role) return;

    // Validar PIN si se ingresó
    if (pin && (pin.length !== 4 || !/^\d{4}$/.test(pin))) {
      alert('El PIN debe ser de exactamente 4 dígitos numéricos');
      return;
    }

    const employeeData = {
      id: editingEmployee ? editingEmployee.id : Date.now(),
      name,
      role,
      ...(pin ? { pin } : {})  // solo incluir pin si se ingresó
    };

    if (editingEmployee) {
      onUpdateEmployee(employeeData);
    } else {
      onAddEmployee(employeeData);
    }

    handleCancelEdit();
  };

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">Gestión de Empleados</h3>

      <form onSubmit={handleSubmit} className="mb-6">
        <h4 className="text-md font-semibold text-[#3F1907] mb-2">
          {editingEmployee ? 'Editar Empleado' : 'Agregar Empleado'}
        </h4>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Nombre</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>

          <div>
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Rol</label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            >
              <option value="">Seleccionar rol</option>
              <option value="Administrador">Administrador</option>
              <option value="Gerente">Gerente</option>
              <option value="Cajero">Cajero</option>
              <option value="Barista">Barista</option>
              <option value="Mesero">Mesero</option>
            </select>
          </div>

          {/* 🔥 NUEVO: campo PIN */}
          <div>
            <label className="block text-[#3F1907] text-sm font-bold mb-1">
              PIN (4 dígitos)
            </label>
            <input
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
              placeholder={editingEmployee ? "Dejar vacío para no cambiar" : "1234"}
              maxLength={4}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200"
        >
          {editingEmployee ? 'Actualizar Empleado' : 'Guardar Empleado'}
        </button>

        {editingEmployee && (
          <button
            type="button"
            onClick={handleCancelEdit}
            className="w-full bg-gray-500 hover:bg-gray-600 text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200 mt-2"
          >
            Cancelar Edición
          </button>
        )}
      </form>

      <h4 className="text-md font-semibold text-[#3F1907] mb-2">Lista de Empleados</h4>

      {employees.length === 0 ? (
        <p className="text-[#3F1907]">No hay empleados registrados.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#58735A]">
            <thead className="bg-[#58735A]">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Nombre</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Rol</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">PIN</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">
              {employees.map(employee => (
                <tr key={employee.id}>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{employee.name}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">{employee.role}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                    {employee.pin ? '****' : <span className="text-gray-400 text-xs">Sin PIN</span>}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907] space-x-2">
                    <button
                      onClick={() => handleEdit(employee)}
                      className="text-blue-500 hover:text-blue-700 transition duration-200"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => onDeleteEmployee(employee.id)}
                      className="text-red-500 hover:text-red-700 transition duration-200"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default POSEmployeeManagement;